import jsbridge from "@xpeng/js-bridge";
import { loadMain } from "../components/amap/loader";

export function getLocation(): Promise<{
  coords: {
    latitude: number;
    longitude: number;
  };
  address: string;
}> {
  return new Promise((resolve, reject) => {
    // jsbridge.callHandler('requestLocation')
    //     .then((data) => {
    //         const res = typeof data === 'string' ? JSON.parse(data) : data;
    //         if (res.code === 0 && data.data.address) {
    //             resolve(data.data);
    //         } else {
    console.log(`++++++++ use amap get location`);
    loadMain().then(() => {
      console.log(`++++++++ use amap get location: load success`);
      window.AMap.plugin("AMap.Geolocation", function () {
        console.log(`++++++++ use amap get location: use plugin success`);
        var geolocation = new window.AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
          buttonOffset: new AMap.Pixel(10, 20),
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          buttonPosition: "RB",
        });

        geolocation.getCurrentPosition(function (status, result) {
          if (status === "complete") {
            onComplete(result);
          } else {
            onError(result);
          }
        });
      });

      function onComplete(data) {
        console.log(
          `++++++++ use amap get location success: ${JSON.stringify(data)}`
        );
        // data是具体的定位信息
        resolve({
          coords: {
            latitude: data.position.getLat(),
            longitude: data.position.getLng(),
          },
          address: data.formattedAddress,
        });
      }

      function onError(data) {
        console.log(`++++++++ use amap get location error: ${JSON.stringify(
          data
        )});
                                )}`);
        // 定位出错
        reject(data);
      }
    });
    // }
  });
  // })
}

// 进行IP城市查询
export function getCityCode(): Promise<{
  country: string;
  center: Array<number>;
  province: string;
  city: string;
  citycode: string;
  adcode: string;
}> {
  return new Promise((resolve, reject) => {
    loadMain().then(() => {
      console.log(`++++++++ use amap getCityInfo`);
      window.AMap.plugin("AMap.Geolocation", function () {
        console.log(`++++++++ use amap getCityInfo: use plugin success`);
        var geolocation = new window.AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
          buttonOffset: new AMap.Pixel(10, 20),
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          buttonPosition: "RB",
        });

        geolocation.getCityInfo(function (status, result) {
          if (status === "complete") {
            onComplete(result);
          } else {
            onError(result);
          }
        });
      });
      function onComplete(data) {
        console.log(
          `++++++++ use amap getCityInfo success: ${JSON.stringify(data)}`
        );
        resolve(data);
      }

      function onError(data) {
        console.log(
          `++++++++ use amap getCityInfo error: ${JSON.stringify(data)}`
        );
        reject(data);
      }
    });
  });
}

// 获取用户当前的精确位置信息
// 调用此方法可实现打开页面自动定位，如不调用此方法可实现点击位置触发后定位。
export function getCurrentPosition(): Promise<{
  addressComponent: {
    adcode: string;
    city: string;
    province: string;
    citycode: string;
  };
  position: {
    lat: number;
    lng: number;
  };
}> {
  return new Promise((resolve, reject) => {
    loadMain().then(() => {
      console.log(`++++++++ use amap getCurrentPosition`);
      window.AMap.plugin("AMap.Geolocation", function () {
        console.log(`++++++++ use amap getCurrentPosition: use plugin success`);
        var geolocation = new window.AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 3000,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
        });

        geolocation.getCurrentPosition(function (status, result) {
          if (status === "complete") {
            onComplete(result);
          } else {
            onError(result);
          }
        });
      });
      function onComplete(data) {
        console.log(
          `++++++++ use amap getCurrentPosition success: ${JSON.stringify(
            data
          )}`
        );
        resolve(data);
      }

      function onError(data) {
        console.log(
          `++++++++ use amap getCurrentPosition error: ${JSON.stringify(data)}`
        );
        reject(data);
      }
    });
  });
}


// 发送地址到车
export function handleSendToVehicle(
  latitude?: number,
  longitude?: number,
  name?: string,
  label?: string
) {
  jsbridge.callHandler("sendAddress", {
    userName: name,
    label: label,
    latitude: latitude,
    longitude: longitude,
  });
}